<template>
  <div class="setting-component">
    <div class="form-group">
      <label for="once-twice-sold" class="form-label">
        {{ trans("live.tabs.settings.hotkeys_tab.labels.once_twice_sold_hot_key") }}
      </label>
      <custom-hot-key-input
        v-model="hotkeysData.once_twice_sold_hot_key"
        input-id="once-twice-sold"
        type="text"
        scope="pass_lot_hot_key"
        with-clear
        input-class="input" />
    </div>
    <div class="form-group-fields">
      <div class="form-group">
        <label class="form-label" for="book-bid-key-label">
          {{ trans("live.tabs.settings.hotkeys_tab.labels.book_bid_hot_key") }}
        </label>
        <custom-hot-key-input
          v-model="hotkeysData.book_bid_hot_key"
          input-id="book-bid-key-label"
          type="text"
          scope="pass_lot_hot_key"
          with-clear
          input-class="input" />
      </div>
      <div class="form-group">
        <label class="form-label" for="book-bid-first-key-label">
          {{ trans("live.tabs.settings.hotkeys_tab.labels.book_bid_first_hot_key") }}
        </label>
        <custom-hot-key-input
          v-model="hotkeysData.book_bid_first_hot_key"
          input-id="book-bid-first-key-label"
          type="text"
          scope="book_bid_first_hot_key"
          with-clear
          input-class="input" />
      </div>
    </div>
    <div class="form-group-fields">
      <div class="form-group">
        <label class="form-label" for="pass-lot-key-label">
          {{ trans("live.tabs.settings.hotkeys_tab.labels.pass_lot_hot_key") }}
        </label>
        <custom-hot-key-input
          v-model="hotkeysData.pass_lot_hot_key"
          input-id="pass-lot-key-label"
          type="text"
          scope="book_bid_hot_key"
          with-clear
          input-class="input" />
      </div>
      <div class="form-group">
        <label class="form-label" for="retract-lot-key-label">
          {{ trans("live.tabs.settings.hotkeys_tab.labels.retract_bid_hot_key") }}
        </label>
        <custom-hot-key-input
          v-model="hotkeysData.retract_bid_hot_key"
          input-id="retract-lot-key-label"
          type="text"
          scope="retract_bid_hot_key"
          with-clear
          input-class="input" />
      </div>
    </div>
    <div class="action-block">
      <button class="btn btn-blue action" @click="save">
        {{ trans("live.tabs.settings.hotkeys_tab.actions.save") }}
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { useAuctionStore } from "@/stores/AuctionStore";
  import { ref, watch } from "vue";
  import { trans } from "@/utils/trans";
  import CustomHotKeyInput from "@/components/_partials/widget/CustomHotKeyInput.vue";
  import apiClient from "@/services/api";
  import { useToast } from "primevue/usetoast";
  import { HotKeyEnum } from "@/enum";
  const toast = useToast();

  const auctionStore = useAuctionStore();

  const parseValues = (value: string[] | string | null | undefined) => {
    if (value) {
      if (typeof value === "string") {
        return JSON.parse(value);
      } else {
        return value;
      }
    }
    return [];
  };

  const hotkeysData = ref({
    once_twice_sold_hot_key: parseValues(auctionStore.liveSettings?.once_twice_sold_hot_key),
    pass_lot_hot_key: parseValues(auctionStore.liveSettings?.pass_lot_hot_key),
    book_bid_first_hot_key: parseValues(auctionStore.liveSettings?.book_bid_first_hot_key),
    book_bid_hot_key: parseValues(auctionStore.liveSettings?.book_bid_hot_key),
    retract_bid_hot_key: parseValues(auctionStore.liveSettings?.retract_bid_hot_key)
  });

  watch(
    () => auctionStore.liveSettings,
    (nv) => {
      hotkeysData.value.once_twice_sold_hot_key = parseValues(nv?.once_twice_sold_hot_key);
      hotkeysData.value.pass_lot_hot_key = parseValues(nv?.pass_lot_hot_key);
      hotkeysData.value.book_bid_first_hot_key = parseValues(nv?.book_bid_first_hot_key);
      hotkeysData.value.book_bid_hot_key = parseValues(nv?.book_bid_hot_key);
      hotkeysData.value.retract_bid_hot_key = parseValues(nv?.retract_bid_hot_key);
    },
    { deep: true }
  );

  const save = () => {
    const data = {
      once_twice_sold_hot_key: JSON.stringify(hotkeysData.value.once_twice_sold_hot_key),
      pass_lot_hot_key: JSON.stringify(hotkeysData.value.pass_lot_hot_key),
      book_bid_first_hot_key: JSON.stringify(hotkeysData.value.book_bid_first_hot_key),
      book_bid_hot_key: JSON.stringify(hotkeysData.value.book_bid_hot_key),
      retract_bid_hot_key: JSON.stringify(hotkeysData.value.retract_bid_hot_key)
    };

    apiClient.put(auctionStore.routes["auctions.update_live_settings"], data).then((response) => {
      if (response.data.status && response.data.settings) {
        auctionStore.$patch(response.data.settings);
      } else {
        console.log(response, response.data?.message);
      }
      toast.add({
        severity: response.data.status ? "success" : "error",
        summary: trans("live.toast." + (response.data.status ? "success" : "error")),
        detail: response.data.message || trans("live.toast.unknown_error"),
        life: 6000
      });
    });
  };
</script>

<style lang="scss" scoped>
  .setting-component {
    .form-group-fields {
      .form-group {
        margin-top: 10px;

        @media screen and (max-width: 1024px) {
          margin-top: 0;
        }
      }
    }
  }
</style>
